import * as React from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";

import { Product } from "../../../models";
import { RootState, Dispatch } from "../../../store/types";
import { LoadingSpinner } from "../../../components";
import SearchInput from "./SearchInput";
import SuggestionItem from "./SuggestionItem";
import * as selectors from "../selectors";
import * as actions from "../actions";
import { ProductSearchState } from "../reducer";

export interface ProductSearchContainerProps extends ProductSearchState {
  updateSearchValue: (val: string) => void;
  searchProducts: (q: string) => void;
  onProductChoice: (product: Product) => void;
  hideSuggestions: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  productSearchHook?: (input: HTMLInputElement) => void;
  className?: string;
  disableDropdown?: boolean;
}

class ProductSearchContainer extends React.Component<
  ProductSearchContainerProps
> {
  public componentDidMount() {
    this.props.hideSuggestions();
  }

  public render() {
    return (
      <SearchInput
        className={this.props.className}
        disableDropdown={this.props.disableDropdown}
        value={this.props.searchValue}
        onChange={this.handleSearch}
        onKeyDown={this.props.onKeyDown}
        showSuggestions={this.props.isSuggestionsShown}
      >
        {this.renderSuggestionItems()}
      </SearchInput>
    );
  }

  private handleSearch = (
    event: React.SyntheticEvent<HTMLInputElement>,
  ): void => {
    const input = event.target as HTMLInputElement;

    this.props.updateSearchValue(input.value);
    this.props.searchProducts(input.value);
    if (this.props.productSearchHook) {
      this.props.productSearchHook(input);
    }
  };

  private renderSuggestionItems() {
    if (this.props.isSuggestionsLoading) {
      return <LoadingSpinner medium />;
    }

    return this.props.suggestions.map((product, i) => (
      <SuggestionItem
        key={i}
        product={product}
        onClick={this.bindProductChoice(product)}
      />
    ));
  }

  private bindProductChoice = (product: Product) => () => {
    this.props.onProductChoice(product);
    this.props.hideSuggestions();
  };
}

const mapStateToProps = (
  state: RootState,
): Partial<ProductSearchContainerProps> => ({
  searchValue: selectors.searchValue(state),
  suggestions: selectors.suggestions(state),
  isSuggestionsLoading: selectors.isSuggestionsLoading(state),
  isSuggestionsShown: selectors.isSuggestionsShown(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<ProductSearchContainerProps> => ({
  updateSearchValue: (val: string) => dispatch(actions.setSearchVal(val)),
  hideSuggestions: () => dispatch(actions.setSuggestionsVisiblity(false)),
  searchProducts: debounce(
    (q: string) => dispatch(actions.searchProducts(q)),
    300,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  ProductSearchContainer,
);



// WEBPACK FOOTER //
// ./src/routes/ProductSearch/components/ProductSearchContainer.tsx